import {
  IWizardHostState,
  TWizardStepComponentEditable,
  WIZARD_HOST_STEPS,
  WIZARD_HOST_STEPS_PATHS
} from "../../../interfaces";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { UserAPI } from "../../../../../API/userApi";
import { RcFile } from "antd/lib/upload/interface";
import { getStepErrorsFromResponse } from "../../../utils";
import { WizardStepAvatarView } from "../../../Student/Steps/WizardStepAvatar";

const statePath = WIZARD_HOST_STEPS_PATHS[WIZARD_HOST_STEPS.Avatar];
export const WizardStepAvatar: TWizardStepComponentEditable<IWizardHostState> =
  forwardRef(({ state, viewonly, readonly }, ref) => {
    const [errors, setErrors] = useState<{ user_image: string } | null>(null);

    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const save = () => {
      setErrors(null);
      if (!selectedFile && state[statePath]?.avatar_thumbnail_url) {
        return Promise.resolve(state);
      }
      return UserAPI.wizardHostSaveAvatar({
        user_image: selectedFile ? (selectedFile as RcFile) : null
      })
        .then((result) => {
          return {
            ...state,
            [statePath]: result
          };
        })
        .catch((e) => {
          const errors = getStepErrorsFromResponse(e) as {
            user_image: string;
          } | null;
          if (errors) {
            setErrors(errors);
          } else {
            setErrors({
              user_image:
                e?.response?.status === 413
                  ? "File is too big, try smaller image"
                  : "Upload error, try another file, possibly smaller"
            });
          }

          return Promise.reject(e);
        });
    };

    useImperativeHandle(ref, () => ({
      save: save
    }));

    return (
      <WizardStepAvatarView
        avatarThumbnailUrl={state[statePath]?.avatar_thumbnail_url}
        errors={errors}
        onFileChange={(file) => {
          setSelectedFile(file);
        }}
        readonly={readonly}
        viewonly={viewonly}
      />
    );
  });
